<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="20">
<!--        <el-col :span="4">-->
<!--          <el-button type="primary" icon="plus" @click="editInfo()">添加商品</el-button>-->
<!--        </el-col>-->
        <el-col :md="6" :lg="6">
          <el-input placeholder="商品货号，多个货号间请用','号分隔" v-model="sku_bn" clearable @clear="sku_bnSearch" @keyup.enter.native="sku_bnSearch" size="mini">
            <el-button slot="append" icon="el-icon-search" @click="sku_bnSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="9" :lg="9">
          <el-button size="mini" type="primary" @click="exportData" v-loading="exportLoading" v-if="exportLoading == false">导出</el-button>
          <el-button size="mini" type="primary" v-loading="exportLoading" element-loading-text="拼命导出中..." v-else>导出</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表-优选商品’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-col>
      </el-row>
      <el-dialog title="报表下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{downloadName}}</a>
        </template>
      </el-dialog>
      <el-table :data="skuListData" :height="wheight-210"  v-loading="loading"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
<!--        <el-table-column prop="id" label="ID" width="100"></el-table-column>-->
        <el-table-column prop="sku_id" label="商品ID" width="80"></el-table-column>
        <el-table-column prop="cat_id" label="分类ID" width="66"></el-table-column>
        <el-table-column prop="sku_name" label="商品名称" width="130"></el-table-column>
<!--        <el-table-column prop="cat_name" label="分类名称" width="130"></el-table-column>-->
        <el-table-column prop="sku_bn" label="商品货号" width="100"></el-table-column>
        <el-table-column label="图片" width="100">
          <template slot-scope="scope">
            <el-popover placement="right" width="240" trigger="hover" >
            <img :src="scope.row.image_default_id" style="width:100%;">
            <el-button type="text" slot="reference"><img style="width:50px;height:50px;" :src="scope.row.image_default_id"></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="销售价" width="90"></el-table-column>
        <el-table-column prop="rate_1" label="自定义分佣" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_rate_custom == 1">否</el-tag>
            <el-tag v-else type="danger">是</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pcate_name" label="所属推类" width="90"></el-table-column>
        <el-table-column prop="rate_1" label="分佣比例" width="90"></el-table-column>
        <el-table-column prop="brokerage" label="佣金" width="90"></el-table-column>
<!--        <el-table-column prop="cost" label="成本价" width="50"></el-table-column>-->
<!--        <el-table-column prop="mktprice" label="市场价" width="50"></el-table-column>-->
        <el-table-column prop="p_order" label="排序" width="70"></el-table-column>
        <el-table-column prop="is_share" label="推广" width="70">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_share=='1'">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="marketable" label="状态" width="100">
          <template slot-scope="scope">
              <el-tag v-if="scope.row.marketable=='true'">上架</el-tag>
              <el-tag v-else type="danger">下架</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button type="text" @click="editInfo(scope.row)" class="btn-gap">编辑</el-button>
            <el-popover
              placement="right"
              width="450"
              trigger="hover">
              <div class="operating-icons">
                <el-button type="text" @click="deleteSkuAction(scope.$index, scope.row)" class="btn-gap">删除</el-button>
              </div>
              <el-button type="text" slot="reference"><i class="iconfont icon-angle-double-right"></i></el-button>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background   layout="prev, pager, next, total" @current-change="handleCurrentChange" :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>

      <el-dialog  :title="dialogTitle" class="right-dialog" :visible.sync="editInfoDialog" :before-close="handleCancelLabelsDialog">
      <template>
        <el-form>
          <el-form-item label-width="100px" label="商品ID">
            <el-input v-model="form.sku_id" placeholder="商品ID" disabled></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="商品货号">
            <el-input v-model="form.sku_bn" placeholder="商品货号" disabled></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="商品名称">
            <el-input v-model="form.sku_name" placeholder="商品名称" disabled></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="限量团购">
            <el-input v-model="form.max_sell" placeholder="限量团购" type="number"></el-input>
          </el-form-item>
<!--          <el-form-item label-width="100px" label="关键词">-->
<!--            <el-input v-model="form.sku_tab" placeholder="关键词"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label-width="100px" label="分享文案">
            <el-input v-model="form.share_con" placeholder="分享文案"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="优惠券ID">
            <el-input v-model="form.coupon_id" placeholder="优惠券ID" type="number"></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="设置分佣">
            <el-radio-group v-model="form.is_rate_custom" size="small">
              <el-radio :label="0">自定义分佣比例</el-radio>
              <el-radio :label="1">关联商品推类</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.is_rate_custom == 0" label-width="100px" label="分佣比例">
            <el-input v-model="form.rate_1" placeholder="分佣比例" type="number"></el-input>
          </el-form-item>
          <el-form-item v-else-if="form.is_rate_custom == 1" label-width="100px" label="分佣比例">
            <el-select v-model="form.promotecate_id" placeholder="请选择商品推类">
              <el-option
                v-for="item in promotecate_list"
                :key="item.name"
                :label="item.pcate_name + ' 类        ' + item.pcate_ratio"
                :value="item.id">
                <span style="float: left">{{ item.pcate_name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.pcate_ratio }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label-width="100px" label="是否推广">
            <el-radio-group v-model="form.is_share" size="small">
              <el-radio-button :label="'0'">否</el-radio-button>
              <el-radio-button :label="'1'">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="100px" label="推广时间">
            <el-col :span="20">
              <el-date-picker
                v-model="activity_date"
                type="datetimerange"
                range-separator="至"
                start-placeholder="推广开始时间"
                end-placeholder="推广结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']">
              </el-date-picker>
            </el-col>
          </el-form-item>

          <el-form-item label-width="100px" label="排序">
            <el-input v-model="form.p_order" placeholder="排序" type="number"></el-input>
          </el-form-item>
<!--          <el-form-item label-width="100px" label="动态排序">-->
<!--            <el-input v-model="form.d_order" placeholder="动态排序"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label-width="100px" label="优卡商品折扣">
            <el-input v-model="form.proportion" placeholder="优卡商品折扣" type="number"></el-input>
          </el-form-item>
<!--          <el-form-item label-width="100px" label="单赠品数量">-->
<!--            <el-input v-model="form.gift_limit" placeholder="单赠品数量"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label-width="100px" label="是否优卡专区">
            <el-radio-group v-model="form.is_youka" size="small">
              <el-radio-button :label="'0'">否</el-radio-button>
              <el-radio-button :label="'1'">是</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="100px" label="宽图" prop="udfimg">
            <div @click="handleImgPicker('udfimg')" class="upload-box">
              <img v-if="form.udfimg" :src="form.udfimg" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
            <div class="frm-tips">
              建议尺寸680*380
            </div>
          </el-form-item>
          <el-form-item label-width="100px" label="图片" prop="image_default_id">
            <div @click="handleImgPicker('image_default_id')" class="upload-box">
              <img v-if="form.image_default_id" :src="form.image_default_id" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
            <div class="frm-tips">
              建议尺寸600*600
            </div>
          </el-form-item>
          <el-form-item label-width="100px" label="缩略图" prop="thumbnail_pic">
            <div @click="handleImgPicker('thumbnail_pic')" class="upload-box">
              <img v-if="form.thumbnail_pic" :src="form.thumbnail_pic" class="avatar"/>
              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
            </div>
            <div class="frm-tips">
              建议尺寸300*300
            </div>
          </el-form-item>
<!--          <el-form-item label-width="100px" label="推广小图标" prop="tui_icon">-->
<!--            <div @click="handleImgPicker('tui_icon')" class="upload-box">-->
<!--              <img v-if="form.tui_icon" :src="form.tui_icon" class="avatar"/>-->
<!--              <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>-->
<!--            </div>-->
<!--          </el-form-item>-->

          <el-form-item label-width="100px" label="营销图标">
            <el-select v-model="form.tui_icon" placeholder="请选择">
              <el-option
                v-for="item in iconList"
                :key="item.id"
                :label="item.title"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="content-center">
            <el-button type="primary" @click="editInfoSubmit()">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </el-dialog>

    <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    ></imgPicker>

    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import {getSkuList, updateSkuListInfo, iconsList, deleteSku, skuExport, getSkuPromoteCateList} from '../../../api/sharer'
import imgPicker from '@/components/imageselect'
import {mapGetters} from "vuex";
export default {
  components: { imgPicker },
  data () {
    return {
      total_count: 0,
      dialogTitle: '',
      loading: false,
      exportLoading: false,
      skuListData: [],
      params: {
        page: 1,
        pageSize: 20
      },
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      form: {
        id: '',
        sku_name: '',
        max_sell: '',
        // sku_tab: '',
        share_con: '',
        coupon_id: '',
        rate_1: '',
        is_share: '',
        is_rate_custom: 0, // 是否使用自定义分佣比例
        promotecate_id: 0, // 关联商品推类ID
        p_order: '',
        // d_order: '',
        proportion: '',
        // gift_limit: '',
        is_youka: '',
        udfimg: '',
        thumbnail_pic: '',
        image_default_id: '',
        tui_icon: ''
      },
      promotecate_list: [],
      iconList: [],
      activity_date: '',
      sku_bn: '',
      editInfoDialog: false,
      pickerImgType: '',
      imgDialog: false,
      isGetImage: false
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    // 获取商品推类列表
    getPromoteCateList() {
      getSkuPromoteCateList().then(res => {
        this.promotecate_list = res.data.data.list
      })
    },
    getItems (filter) {
      this.loading = true
      getSkuList(filter).then(response => {
        this.skuListData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
        this.exportLoading = false
      })
    },
    handleCurrentChange (val) {
      this.params.page = val
      this.getItems(this.params)
    },
    editInfo (row = '') {
      this.editInfoDialog = true
      if (row) {
        // console.log(row)
        this.form = row
        this.form.rate_1 = row.rate_1 ? row.rate_1.replace(/\s/g,"") : ''
        this.activity_date = row.uptime ? [row.up_date, row.down_date] : ''
        this.dialogTitle = '编辑商品'
      }
    },
    editInfoSubmit () {
      let data = {
        id: this.form.id,
        max_sell: this.form.max_sell,
        // sku_tab: this.form.sku_tab,
        share_con: this.form.share_con,
        coupon_id: this.form.coupon_id,
        price: this.form.price,
        rate_1: this.form.rate_1,
        is_rate_custom: this.form.is_rate_custom, // 是否使用自定义分佣比例
        promotecate_id: this.form.promotecate_id, // 关联商品推类ID
        is_share: this.form.is_share,
        uptime: this.activity_date ? this.activity_date[0] : 0,
        downtime: this.activity_date ? this.activity_date[1] : 0,
        p_order: this.form.p_order,
        // d_order: this.form.d_order,
        proportion: this.form.proportion,
        // gift_limit: this.form.gift_limit,
        is_youka: this.form.is_youka,
        udfimg: this.form.udfimg,
        thumbnail_pic: this.form.thumbnail_pic,
        image_default_id: this.form.image_default_id,
        tui_icon: this.form.tui_icon
      }
      updateSkuListInfo(data).then(res => {
        this.$message({ type: 'success', message: '更新成功'})
        this.editInfoDialog = false
        this.getItems(this.params)
      })
    },
    deleteSkuAction (index, row) {
      this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSku(row.id).then(response => {
          if (response.data.data && response.data.data.status) {
            this.skuListData.splice(index, 1)
            this.$message({
              message: '删除商品成功',
              type: 'success',
              duration: 2 * 1000
            })
          } else {
            this.$message({
              type: 'info',
              message: '删除商品失败'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    icons () {
      iconsList({page: 1, pageSize: 500}).then(res => {
        for (let item of res.data.data.list) {
          this.iconList.push({title: item.title, id: item.id})
        }
      })
    },
    getParams () {
      this.params.sku_bn = this.sku_bn
    },
    sku_bnSearch (e) {
      this.params.page = 1
      this.getParams()
      this.getItems(this.params)
    },
    handleCancelLabelsDialog () {
      this.editInfoDialog = false
    },
    pickImg (data) {
      this.form[this.pickerImgType] = data.url
      this.imgDialog = false
    },
    handleImgPicker (pickerImgType) {
      this.pickerImgType = pickerImgType
      this.imgDialog = true
      this.isGetImage = true
    },
    closeImgDialog () {
      this.imgDialog = false
      this.isGetImage = false
    },
    handleSelectionChange (val) {
      console.log(val)
    },
    exportData () {
      this.getParams()
      this.exportLoading = true
      skuExport(this.params).then(response => {
        this.exportLoading = false
        if (response.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表-优选商品中下载'
          })
          return
        } else if (response.data.url) {
          this.downloadUrl = response.data.url
          this.downloadName = response.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    }
  },
  mounted () {
    this.icons()
    this.getItems(this.params)
    this.getPromoteCateList()
  },
  watch: {
    // 分页全选-监听数据变化
    skuListData: {
      handler (value) {
        if (this.allCheck) {
          this.skuListData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          })
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped lang="scss">
.mobile-editor {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// sku_list.vue?917c7a18